export default __webpack_public_path__ + "static/media/wallet-solid.3b2e3bb6.svg";